<template>
  <div>
    <b-form>
      <b-row>
        <b-col sm="4">
          <b-form-group label-for="basicSelect" v-if="dossierLength > 1">
            <label for="categorie"><strong>Dossier prestation</strong></label>
            <b-form-select ref="dossierSelect"
                           id="basicSelect"
                           :plain="true"
                           :options="dossierOptions"
                           v-model="selectedDossier"
            ></b-form-select>
          </b-form-group>
          <b-form-group label-for="basicSelect" v-else>
            <label><strong>Dossier prestation</strong></label>
            <b-form-input type="text" ref="dossier" :value="dossier" :disabled="true" v-model="dossier"/>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="date_du"><strong>Période du</strong></label>
            <b-form-input type="date" id="date_du" v-model="dateDu"
                          :class="{hasError: errors.dateDu !== ''}"></b-form-input>
            <span class="field-error">{{ errors.dateDu }}</span>
          </b-form-group>
        </b-col>
        <b-col sm="4">
          <b-form-group>
            <label for="date_au"><strong>Au</strong></label>
            <b-form-input type="date" id="date_au" v-model="dateAu"
                          :class="{hasError: errors.dateAu !== ''}"></b-form-input>
            <span class="field-error">{{ errors.dateAu }}</span>
          </b-form-group>
        </b-col>
      </b-row>
      <div slot="footer">
        <b-button type="button" @click="submitForm()" size="md" variant="primary">
          <i class="fa fa-download"></i> Télécharger
        </b-button>
      </div>
    </b-form>
    <b-modal title="Problème dans les périodes sélectionnées" v-model="myModal" @ok="myModal = false">
      {{ textErrorPeriode }}
    </b-modal>
  </div>
</template>

<script>
  import {getBaseUrl, getProvider, getIdToken, getAccessToken} from '../utils/auth'
  import {en, fr} from 'vuejs-datepicker/dist/locale'

  export default {
    props: ['benefId'],
    data() {
      return {
        dateDu: null,
        dateAu: null,
        selectedDossier: '',
        dossierOptions: [],
        dossier: '',
        dossierLength: '',
        problemePeriode: false,
        lienContact: false,
        myModal: false,
        textErrorPeriode: '',
        errors: {dateAu: '', dateDu: ''},
        fr: fr,
        DatePickerFormat: 'dd/MM/yyyy'
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken()
      this.$axios.defaults.headers.common['Accept'] = 'application/json'
      this.$axios.defaults.headers.common['Provider'] = getProvider()
    },
    mounted() {
      if (this.benefId) {
        this.getDossiers()
      }
    },
    methods: {
      getDossiers() {
        let self = this
        // this.$store.commit("IS_LOADING", true)
        this.$axios.get('/espaceBeneficiaire/attestations/dossier/' + this.benefId)
          .then((response) => {
            this.dossierOptions = response.data.numerosDossier
            this.dossierLength = Object.keys(this.dossierOptions).length
            this.dossier = Object.keys(this.dossierOptions)[0]
            // this.$store.commit('IS_LOADING', false)
          }).catch(function (error) {
          self.$store.commit('IS_LOADING', false)
          let errorText = 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI'
          if (error.response && error.response.status === 403 && self !== undefined) {
            errorText = 'Accès non autorisé.'
          }
          self.$swal(
            {
              position: 'top',
              type: 'error',
              title: 'Attention !!',
              text: errorText,
              showConfirmButton: false,
              timer: 5000
            }
          )
        })
      },
      downloadFile(response, numDecompte, category) {
        let newBlob = new Blob([response.data], {type: 'application/pdf'})
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
        }
        const data = window.URL.createObjectURL(newBlob)
        var link = document.createElement('a')
        link.href = data
        if (category == 'decompte') {
          link.download = 'decompte_' + numDecompte + '.pdf'
        } else {
          link.download = 'attestation' + numDecompte + '.pdf'
        }
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
        window.open(link, '_blank')
        setTimeout(function () {
          window.URL.revokeObjectURL(data)
        }, 100)
      },
      submitForm() {
        if (this.validateData()) {
          let self = this
          let dataPost = {}
          dataPost.date_du = this.dateDu
          dataPost.date_au = this.dateAu
          dataPost.numeroDossier = this.selectedDossier ? this.selectedDossier : this.dossier
          dataPost.typeRente = this.dossierOptions[dataPost.numeroDossier].type_rente
          dataPost.benefId = this.benefId;

          this.$store.commit('IS_LOADING', true)
          this.$axios.post('/espaceBeneficiaire/beneficiaires/attestation/generer', dataPost, {responseType: 'arraybuffer'})
            .then((response) => {
              this.$event.emit('refreshBeneficiaire');
              this.$store.commit('IS_LOADING', false)
              this.downloadFile(response, dataPost.numeroDossier, 'attestation')
            })
            .catch(function (error) {
              self.$store.commit('IS_LOADING', false)
              if (self !== undefined && error.response.status === 500) {
                self.$swal(
                  {
                    position: 'top',
                    type: 'error',
                    title: 'Attention !!',
                    text: 'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                    showConfirmButton: false,
                    timer: 5000
                  })
              } else if (error.response && self !== undefined && error.response.status === 403) {
                self.$swal(
                  {
                    position: 'top',
                    type: 'error',
                    title: 'Attention !!',
                    text: 'Accès non autorisé.',
                    showConfirmButton: false,
                    timer: 5000
                  })
              } else if (error.response && self !== undefined && error.response.status === 422) {
                let decodedJson = String.fromCharCode.apply(null, new Uint8Array(error.response.data))
                let data = JSON.parse(decodedJson)
                if (data.erreur === 'indu') {
                  self.textErrorPeriode = 'Nous ne pouvons malheureusement pas afficher votre attestation de versement car celle-ci présente un indu sur la période concernée. Nous vous invitons à modifier la période ou à prendre contact avec votre téléconseiller.'
                  self.problemePeriode = true
                  self.lienContact = true
                  self.myModal = true
                } else if (data.erreur === 'null') {
                  self.textErrorPeriode = 'Nous ne pouvons malheureusement pas afficher votre attestation de versement car celle-ci se révèle nulle sur la période concernée. Nous vous invitons à modifier la période ou à prendre contact avec votre téléconseiller.'
                  self.problemePeriode = true
                  self.lienContact = true
                  self.myModal = true
                } else if (data.erreur === 'rien') {
                  self.textErrorPeriode = 'Vous n\'avez eu aucun versement pendant la période sélectionnée.'
                  self.problemePeriode = true
                  self.lienContact = false
                  self.myModal = true
                }
              }
            })
        }
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        let dateFrom = new Date(this.dateDu)
        let dateTo = new Date(this.dateAu)

        if (this.dateDu === '' || this.dateDu === null) {
          this.errors.dateDu = "Veuillez choisir une date de début de période";
          valid = false;
        }
        if (this.dateAu === '' || this.dateAu === null) {
          this.errors.dateAu = "Veuillez choisir une date de fin de période";
          valid = false;
        }
        if (this.dateAu !== null && this.dateAu !== "") {
          if (dateTo.getTime() < dateFrom.getTime()) {
            this.errors.dateAu = "La date de fin doit être postérieure à la date de début"
            valid = false
          }
        }
        return valid;
      },
      clearErrors() {
        this.errors.dateDu = "";
        this.errors.dateAu = "";
      },
    }
  }
</script>

<style>

</style>
